module.exports = __webpack_public_path__ + "img/t_4.44385848.png";